// Scroll to a page section from the nav.
// Smooth-scrolling across a long distance drags the pinned projects section
// (600vh of horizontal gallery) past the viewer, so long jumps cut instantly
// behind a short fade instead.
const FADE_MS = 220;
let curtain = null;

const getCurtain = () => {
  if (curtain) return curtain;
  curtain = document.createElement('div');
  Object.assign(curtain.style, {
    position: 'fixed',
    inset: '0',
    background: '#fcfcfc',
    opacity: '0',
    pointerEvents: 'none',
    zIndex: '15000',
    transition: `opacity ${FADE_MS}ms ease`,
  });
  document.body.appendChild(curtain);
  return curtain;
};

// Scroll the window to an absolute position, using the same rules as above.
export const scrollToY = (top) => {
  const distance = Math.abs(top - window.scrollY);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo({ top, behavior: 'instant' });
    return;
  }

  if (distance < window.innerHeight * 1.5) {
    window.scrollTo({ top, behavior: 'smooth' });
    return;
  }

  const c = getCurtain();
  c.style.opacity = '1';
  setTimeout(() => {
    window.scrollTo({ top, behavior: 'instant' });
    requestAnimationFrame(() => { c.style.opacity = '0'; });
  }, FADE_MS);
};

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  scrollToY(el.getBoundingClientRect().top + window.scrollY);
};
